<template>
  <a-layout>
    <a-layout-content>
      <a-row>
        <a-col
          :span="24"
          :style="{ 'background-color': '#17A2B8', 'minHeight': '96px' }"
        >
          <a-row type="flex" justify="center">
            <a-col :sm="24" :xl="12" :style="{'color':'#fff','font-size':'14pt'}">
              <a-row type="flex" justify="space-between" align="middle">
                <a-col>
                  <p><router-link to="/" class="logoToHome">彎的工作室
                    <br />
                    Wonder Studio</router-link></p>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>

export default {
  name: 'Nav',
  props: {
    minHeight : String,
  },
  data:()=>{
      return {
      }
  },
  setup:function(){
    
  },
  watch:{
   
  },
  methods:{
  }
}
</script>

<style lang="scss">
.logoToHome{
  color:#fff;
  &:hover{
    color: #fff;
  }
}
</style>